
  import { Vue, Component, Prop } from "vue-property-decorator";
  import UiButton from "@/components/button/ui-button.vue";

  @Component({
    components: {
      UiButton,
    }
  })
  export default class FiltersContainer extends Vue {
    @Prop({ default: "Filters", type: String }) readonly title!: string;
    @Prop({ default: "", type: String }) readonly containerClass!: string;
  }
